import { AdminService } from 'src/modules/admin/services/AdminService';
import { AssessmentsService } from 'src/modules/assessments/services/AssessmentsService';
import { AuthenticationService } from 'src/modules/auth/services/AuthenticationService';
import { TokenAuthenticator } from 'src/modules/auth/services/TokenAuthenticator';
import { UserAuthenticator } from 'src/modules/auth/services/UserAuthenticator';
import { ConnectToAnExpertService } from 'src/modules/connectToExpert/services/ConnectToAnExpertService';
import { CountryService } from 'src/modules/countries/services/CountryService';
import { GoalsService } from 'src/modules/goals/services/GoalsService';
import { LanguageService } from 'src/modules/languages/services/LanguageService';
import { MeditationService } from 'src/modules/meditations/services/MeditationService';
import { ProgramService } from 'src/modules/newPrograms/services/programService';
import { ProvidersService } from 'src/modules/providers/services/ProvidersService';
import { User } from 'src/modules/user/services/UserService';
import { Benefits } from 'src/modules/benefits/services/BenefitsService';
import { NavigationService } from 'src/shared/services/NavigationService';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';
import { MessageService } from 'src/modules/messaging/services/MessageService';
import { ClickwrapService } from 'src/modules/auth/services/ClickwrapService';

export const navigationService = new NavigationService();
export const toastNotificationsService = new ToastNotificationsService();
export const tokenAuthenticator = new TokenAuthenticator(
    toastNotificationsService,
    navigationService,
);
export const userAuthenticator = new UserAuthenticator(toastNotificationsService);
export const authenticationService = new AuthenticationService(
    toastNotificationsService,
    navigationService,
);
export const connectToAnExpertService = new ConnectToAnExpertService(toastNotificationsService);
export const assessmentsService = new AssessmentsService();
export const userService = new User(toastNotificationsService);
export const benefitsService = new Benefits();
export const meditationService = new MeditationService();
export const goalsService = new GoalsService(toastNotificationsService);
export const providersService = new ProvidersService(toastNotificationsService);
export const countriesService = new CountryService(toastNotificationsService);
export const languagesService = new LanguageService(toastNotificationsService);
export const adminService = new AdminService();
export const programService = new ProgramService();

export const messageService = new MessageService(toastNotificationsService);
export const clickwrapService = new ClickwrapService(toastNotificationsService);
